import { FireArmCondition, FireArmPurchaseCondition, FireArmAction } from './constants';

const attributes = {

  firearm_type: {
    friendly: 'Type',
    validations: {
      maxLength: 255,
    },
  },

  firearm_manufacturer: {
    friendly: 'Manufacturer',
    validations: {
      maxLength: 255,
    },
  },

  firearm_model: {
    friendly: 'Model',
    validations: {
      maxLength: 255,
    },
  },

  firearm_caliber: {
    friendly: 'Caliber',
    validations: {
      maxLength: 255,
    },
  },

  firearm_capacity: {
    friendly: 'Capacity',
    validations: {
      maxLength: 255,
    },
  },

  firearm_action: {
    friendly: 'Action',
    validations: {
      type: 'enum',
      enumType: FireArmAction,
    },
  },

  firearm_barrel_length: {
    friendly: 'Barrel Length',
    validations: {
      maxLength: 255,
    },
  },

  firearm_finish: {
    friendly: 'Finish',
    validations: {
      maxLength: 255,
    },
  },

  firearm_serial_no: {
    friendly: 'Serial No.',
    validations: {
      maxLength: 255,
    },
  },

  firearm_manufacturer_date: {
    friendly: 'Year',
    validations: {
      maxLength: 255,
    },
  },

  firearm_accessories: {
    friendly: 'Accessories',
    validations: {
      maxLength: 255,
    },
  },

  firearm_condition: {
    friendly: 'Condition',
    validations: {
      type: 'enum',
      enumType: FireArmCondition,
    },
  },

  firearm_purchase_condition: {
    friendly: 'Purchase Condition',
    validations: {
      type: 'enum',
      enumType: FireArmPurchaseCondition,
    },
  },

  firearm_weight: {
    friendly: 'Weight',
    validations: {
      maxLength: 255,
    },
  },

  firearm_country: {
    friendly: 'Country',
    validations: {
      maxLength: 255,
    },
  },

};

export default attributes;

export const FirearmDefaultSplitAttribute = 'firearm_type';

export const FirearmItemSearchAttributes = [];

export const FirearmOverviewAttributes = ['title', 'firearm_type', 'firearm_manufacturer', 'firearm_model', 'firearm_manufacturer_date', 'firearm_country', 'firearm_condition',
  'rarity', 'market_value', 'quantity', 'inventory_no', 'tags'];

export const FirearmSpecificationAttributes = ['firearm_caliber', 'firearm_capacity', 'firearm_action', 'firearm_barrel_length', 'firearm_weight', 'firearm_finish',
  'firearm_serial_no', 'firearm_accessories'];

export const FirearmPurchaseAttributes = ['purchase_date', 'purchase_price', 'firearm_purchase_condition', 'purchase_contact', 'purchase_notes'];

export const FirearmDetailAttributes = [];

export const FirearmRequiredAttributes = [];

export const FirearmDisplayAttributes = ['firearm_type', 'firearm_manufacturer', 'firearm_model', 'firearm_manufacturer_date', 'firearm_caliber', 'tags'];

export const FirearmSliderGalleryAttributes = {
  titleKey: 'firearm_type',
  subtitleKey: 'firearm_model',
};



// WEBPACK FOOTER //
// ./src/config/firearmDataAttributes.js